import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useMediaQuery } from '@deseretbook/react-utils'
import { Box, Button, useTheme, Text, Link, Placeholder } from '@deseretbook/react-ui'
import PlusCircle from '@deseretbook/icons/react/plus-circle'
import InfoCircle from '@deseretbook/icons/react/info'
import { useActionContext } from '../useActionContext'

/**
 * Lists available options for the product.
 * Everything from watch, view trailer, and purchase options
 *
 * @returns {function} React Component
 */
export const Options = ({
  user = {},
  handleStartLesson,
  isDeseretVideoSubscriber = false,
  isFree = false,
  isDark = false,
}) => {
  const [hasDeseretVideo, setHasDeseretVideo] = useState(isDeseretVideoSubscriber)
  const theme = useTheme()

  const {
    isLoading,
    infoText,
    showInfoIcon,
    helpText,
    helpTextLink,
    userVideoSub,
  } = useActionContext({
    user,
    hasDeseretVideo,
    isFree,
  })

  // For when the content reaches its tablet breakpoint
  const isTabletOrSmaller = useMediaQuery({ maxWidth: 767 })

  return (
    <React.Fragment>
      {isLoading ? (
        <Placeholder>
          <Box width={15}>
            <Placeholder.Text lines={1} />
          </Box>
          <Placeholder.Block width={10} height={2.5} marginBottom={1} />
          <Box width={7}>
            <Placeholder.Text lines={1} />
          </Box>
        </Placeholder>
      ) : (
        <React.Fragment>
          <Box justifyContent="center" isColumn>
            <Box marginBottom={0.5} alignItems="center">
              {showInfoIcon && (
                <InfoCircle
                  width="1rem"
                  height="1rem"
                  color={theme.palette.light.dark}
                  style={{ marginRight: '0.5rem' }}
                />
              )}
              <Text color={isDark ? 'light' : 'secondary'} size="small">
                {infoText}
              </Text>
            </Box>
            <Box paddingRight={isTabletOrSmaller ? 0 : 1} alignItems="center">
              {isFree || hasDeseretVideo ? (
                <Button
                  isFullwidth={isTabletOrSmaller}
                  type="button"
                  icon="play"
                  color="video"
                  onClick={() => {
                    handleStartLesson()
                  }}
                  style={{ backgroundColor: theme.palette.seekPrimary.main }}
                >
                  Watch Now
                </Button>
              ) : (
                <Button
                  isFullwidth={isTabletOrSmaller}
                  type="button"
                  color="video"
                  as="a"
                  href="/video"
                >
                  {userVideoSub && !hasDeseretVideo ? 'Join Deseret Video+' : 'Start a Free Trial'}
                </Button>
              )}

              {!isTabletOrSmaller && (
                <Box paddingLeft={1} alignItems="center">
                  <PlusCircle width="2.5rem" height="2.5rem" color={theme.palette.light.dark} />
                </Box>
              )}
            </Box>
            <Box marginTop={0.5}>
              {helpTextLink ? (
                <Link href={helpTextLink} style={{ color: 'white' }}>
                  <Text color={isDark ? 'light' : 'secondary'} size="tiny">
                    {helpText}
                  </Text>
                </Link>
              ) : (
                <Text color={isDark ? 'light' : 'secondary'} size="tiny">
                  {helpText}
                </Text>
              )}
            </Box>
          </Box>
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

Options.propTypes = {
  user: PropTypes.shape(PropTypes.any),
  isDeseretVideoSubscriber: PropTypes.bool,
  handleStartLesson: PropTypes.func,
  isFree: PropTypes.bool,
  isDark: PropTypes.bool,
}
